


















































































































































































































import schema from 'async-validator'
import {
  Input,
  Form,
  FormItem,
  Select,
  Option,
  Dialog,
  OptionGroup,
  Popover,
} from 'element-ui'
import { mixins } from 'vue-class-component'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import Customer, { MIN_AGE } from '@/models/customer'
import RegistrationData from '@/models/registration-data'

import GroupedErrorValidationMixin from '@/mixins/GroupedErrorValidationMixin.vue'
import { ProfileDataActionTypes } from '@/store/modules/profileData'

@Component({
  components: {
    [Popover.name]: Popover,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [OptionGroup.name]: OptionGroup,
  },
})
export default class PersonalDetailsForm extends mixins(
  GroupedErrorValidationMixin,
) {
  @Prop() customerDetails!: Customer
  @Prop({ default: false }) changePasswordModalVisible!: boolean

  rules = {
    title: [{ required: true, message: 'Title is required' }],
    firstName: [{ required: true, message: 'First Name is required' }],
    lastName: [{ required: true, message: 'Last Name is required' }],
    age: [
      { required: true, message: 'Birth Year is required' },
      {
        type: 'number',
        max: this.maxBirthYear,
        message: 'Customer must be at least 17 years old',
        trigger: 'change',
      },
    ],
    email: [{ type: 'email', message: 'Wrong email format' }],
    nationality: [{ required: true, message: 'Nationality is required' }],
  }

  validator = new schema(this.rules)

  form: RegistrationData = {
    email: '',
    password: '',
    title: '',
    firstName: '',
    lastName: '',
    nationality: '',
    countryCode: '',
    tel: '',
    age: null,
  }

  @Watch('customerDetails')
  fillInForm() {
    const { form, customerDetails, $_ } = this
    const prefilledFields = $_.pick(
      customerDetails,
      Object.keys(form),
    ) as RegistrationData

    this.form = { ...form, ...prefilledFields }
  }

  get nationalities() {
    return this.$store.getters.nationalities
  }

  get countryOptions() {
    return this.$store.getters.countries
  }

  get yearOptions(): number[] {
    const years: number[] = []
    const currentYear = new Date().getFullYear()

    for (let n = MIN_AGE; n <= 100; n++) {
      years.push(currentYear - n)
    }

    return years
  }

  get maxBirthYear() {
    return new Date().getFullYear() - MIN_AGE
  }

  get customerDetailsBlocked() {
    return this.customerDetails.hasActiveBookings
  }

  get customerDetailsWarning() {
    return `Please contact the Sales Team via
            <a href="mailto:sales@sail-croatia.com">sales@sail-croatia.com</a>
            to update passenger information`
  }

  onCustomerDetailsUpdate(updates: { [field: string]: any }) {
    this.validator.validate(this.form, (errors: any) => {
      if (errors) {
        return false
      }
      this.$emit('on-customer-update', updates)
    })
  }

  updateCountryCode(countryCode: string) {
    this.form = { ...this.form, countryCode }
    this.onCustomerDetailsUpdate({ countryCode })
  }

  openChangePasswordModal() {
    this.$emit('on-change-password-modal-open')
  }

  closeChangePasswordModal() {
    this.$emit('on-change-password-modal-close')
  }

  created() {
    this.$store.dispatch(ProfileDataActionTypes.LoadNationalities)
    this.$store.dispatch(ProfileDataActionTypes.LoadCountries)
    this.fillInForm()
  }
}
